/**
 * ヘッダー追従処理
 * 上下スクロールで表示非表示
 */
$(function () {
  (DEBUG = false),
    (log = function (str) {
      if (DEBUG) console.log(str);
    });
  let Timer = [],
    sticky = { header: false },
    visible = { header: false };
  //header 固定
  gsap.to(".ly_header", {
    scrollTrigger: {
      trigger: "body",
      start: "top",
      end: "bottom",
      markers: DEBUG,
      onUpdate: (self) => {
        return;
        log(sticky.header);
        // if(sticky.header === false) return
        clearTimeout(Timer.headerSticky);
        if (self.direction < 0) {
          // 上へスクロール
          if (visible.header === undefined || visible.header !== true) {
            Timer.headerSticky = setTimeout(function () {
              visible.header = true;
              $("body").addClass("header-sticky");
              gsap.fromTo(
                ".ly_header",
                {
                  y: "-100%",
                },
                {
                  y: "0%",
                  duration: 0.5,
                }
              );
            }, 10);
          }
        } else {
          // 下へスクロール
          if (visible.header === undefined || visible.header === true) {
            Timer.headerSticky = setTimeout(function () {
              visible.header = false;
              gsap.to(".ly_header", {
                y: "-100%",
                duration: 0.5,
                onComplete: function () {
                  $("body").addClass("header-sticky");
                },
              });
            }, 10);
          }
        }
      },
    },
  });
  gsap.to(".ly_header", {
    scrollTrigger: {
      trigger: ".ly_header",
      start: "top",
      end: "bottom+=600 center",
      markers: DEBUG,
      onLeave: () => {
        log("Leave");
        // sticky.header = true
      },
      onLeaveBack: () => {
        if (sticky.header === false) return;
        log("Leave back");
        // sticky.header = false
        clearTimeout(Timer.headerSticky);
        $("body").removeClass("header-sticky");
      },
    },
  });
});
/*
const swiper = new Swiper('.swiper', {
  // Optional parameters
  direction: 'vertical',
  loop: true,
});
*/

if (null !== document.querySelector(".ly_hero.splide")) {
  new Splide(".ly_hero.splide", {
    type: "fade",
    rewind: true, // 最後に到達した後、最初に戻る
    perPage: 1, // 表示するスライド枚数
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    cover: false,
    arrows: true,
    pagination: false,
    padding: 0,
    mediaQuery: "min",
    speed: 1000,
    interval: 5000,
    breakpoints: {
      750: {
        type: "fade",
        focus: "center",
        perPage: 1,
        padding: "0",
      },
    },
  }).mount();
}
if (null !== document.querySelector(".ly_hero__restration.splide")) {
  new Splide(".ly_hero__restration.splide", {
    type: "fade",
    rewind: true, // 最後に到達した後、最初に戻る
    perPage: 1, // 表示するスライド枚数
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    cover: false,
    arrows: false,
    pagination: false,
    padding: 0,
    mediaQuery: "min",
    speed: 1000,
    interval: 2500,
    breakpoints: {
      750: {
        type: "fade",
        focus: "center",
        perPage: 1,
        padding: "0",
      },
    },
  }).mount();
}
if (null !== document.querySelector(".bl_news__ticker")) {
  new Splide(".bl_news__ticker", {
    direction: "ttb", // スライダーの方向を指定
    wheel: false, // マウスホイールによるスライダーの移動を有効にする
    waitForTransition: true, // スライダーが移動中にも操作を受け付ける
    // focus     : 'center',
    autoHeight: true,
    autoplay: true,
    perPage: 1,
    height: "1.4rem",
    arrows: false,
    pagination: false,
    // heightRatio: .18, // スライドの高さをスライダーの幅に対する割合で指定
  }).mount();
}

if (
  null !==
  document.querySelector(".splide.bl_showcase__newIn.showcase__carousel")
) {
  new Splide(".splide.bl_showcase__newIn.showcase__carousel", {
    type: "loop",
    rewind: true, // 最後に到達した後、最初に戻る
    //focus     : 'center',
    // autoHeight: true,
    perPage: 2, // 表示するスライド枚数
    perMove: 1, // perPageと同値が良さげ。ページングやArrowの押下時にスライドする枚数。
    arrows: true,
    pagination: false,
    padding: "10%",
    autoplay: "pause",
    autoScroll: {
      speed: 1,
    },
    intersection: {
      inView: {
        autoplay: true,
        autoScroll: true,
      },
      outView: {
        autoplay: false,
        autoScroll: false,
      },
    },
    mediaQuery: "min",
    breakpoints: {
      750: {
        mediaQuery: "min",
        type: "loop",
        drag: "free",
        focus: "center",
        perPage: 4,
        perMove: 1,
        padding: "0",
        autoplay: "pause",
        autoScroll: {
          speed: 1.6,
        },
        intersection: {
          inView: {
            autoplay: true,
            autoScroll: true,
          },
          outView: {
            autoplay: false,
            autoScroll: false,
          },
        },
      },
    },
  }).mount(window.splide.Extensions);
}

document.addEventListener("DOMContentLoaded", function () {
  var elms = document.getElementsByClassName("bl_carouselList");
  sps = [];
  for (var i = 0; i < elms.length; i++) {
    sps[i] = new Splide(elms[i]);
    sps[i].on("active", function (Slide) {
      const parent_class = Slide.slide.getAttribute("data-parent");
      const target_class = Slide.slide.getAttribute("data-target");
      const permalink = Slide.slide.href;
      if (parent_class === null || target_class === null) return;
      const p = $(Slide.slide).parents(parent_class);
      const eyecatch_default = p.attr("data-eyecatch-default");
      let eyecatch = Slide.slide.getAttribute("data-eyecatch");
      if (
        eyecatch_default !== undefined &&
        eyecatch_default !== "" &&
        (eyecatch === null || eyecatch === "")
      ) {
        eyecatch = eyecatch_default;
      }
      p.find(target_class).attr("src", eyecatch);

      if (permalink !== null && permalink !== "") {
        const link = p.find(target_class).parents("a");
        if (link.length) {
          p.find(target_class).parents("a").attr("href", permalink);
        }
      }
    });
    sps[i].mount();
  }
});

(function () {
  // https://greensock.com/forums/topic/29426-httpsgreensockcomforumstopic29426-3d-spinwheel-with-scrolltrigger3d-spinwheel-with-scrolltrigger/

  function createCarousel(parent, name) {
    // 指定collectionのカルーセルをつくる
    if (null !== parent.querySelector("bl_showcase__" + name)) {
      // 存在すれば終了
      return;
    }
    let carousel = document.createElement("div");
    let items = [];
    for (key in CylinderItem[name].items) {
      let tag = "",
        url = CylinderItem[name].items[key].url,
        productname = CylinderItem[name].items[key].name,
        image = CylinderItem[name].items[key].image,
        price = Number(CylinderItem[name].items[key].price).toLocaleString();
      if (CylinderItem[name].items[key].tags !== undefined) {
        tag =
          '<li class="bl_tags_item el_tag">' +
          CylinderItem[name].items[key].tags.join(
            '</li><li class="bl_tags_item el_tag">'
          ) +
          "</li>";
      }
      items.push(
        '<li class="bl_showcase_item hp_fx6 hp_fx3__xs splide__slide">' +
          `<a href="${url}" class="bl_product">` +
          `<div class="bl_product_eyecatch"><img src="${image}" alt="" class="el_img el_img__eyecatchShowcase"/></div>` +
          `<ul class="bl_tags">${tag}</ul>` +
          `<div class="bl_product_name">${productname}</div>` +
          `<div class="bl_product_price">¥${price}</div>` +
          "</a>" +
          "</li>"
      );
    }
    carousel.className =
      "bl_showcase bl_showcase__" + name + "showcase__carousel splide";
    carousel.innerHTML =
      '<div class="splide__track el_splide__track"><ol class="splide__list">' +
      items.join("") +
      "</ol><div>";
    carousel.innerHTML +=
      '<div class="splide__arrows"><button class="splide__arrow splide__arrow--prev el_splide__arrow"></button><button class="splide__arrow splide__arrow--next el_splide__arrow"></button></div>';
    carousel.innerHTML +=
      '<div class="bl_showcase_more bl_more hp_text_center hp_text_left__xs"><a href="./about.html" class="el_btn el_btn__more el_btn__pill hp_font_en">MORE</a></div>';

    let showcase = parent.querySelector(".bl_showcase");
    if (showcase !== undefined && showcase !== null) {
      // 既存カルーセルは削除する
      showcase.remove();
    }
    parent.append(carousel);

    // カルーセル実行
    new Splide(carousel, {
      type: "loop",
      // rewind: true, // 最後に到達した後、最初に戻る
      //focus     : 'center',
      // autoHeight: true,
      perPage: 2, // 表示するスライド枚数
      perMove: 1, // perPageと同値 or 1 が良さげ。ページングやArrowの押下時にスライドする枚数。
      arrows: true,
      pagination: false,
      padding: "10%",
      // heightRatio: .18, // スライドの高さをスライダーの幅に対する割合で指定
      mediaQuery: "min",
      breakpoints: {
        750: {
          //focus: 'center',
          perPage: 4,
          perMove: 1,
          padding: "0",
        },
      },
    }).mount();
    return carousel;
  }
  document.querySelectorAll(".bl_cylinder").forEach(function (elm) {
    // ページ内の回転要素を処理する
    let wheel = elm.querySelector(".bl_cylinder_wheel");
    const numItems = wheel.querySelectorAll(".bl_cylinder_item").length;
    let divian = 2;
    if (window.matchMedia("(min-width: 750px)").matches) {
      divian = 0.85; // 円柱の太さ調整
    }
    let numLines = numItems * 2,
      radius = (numLines * 10) / divian,
      angle = 360 / numLines,
      origin = `50% 50% -${radius}px`;

    const reverse = false;
    let txt = wheel.querySelectorAll(".bl_cylinder_item");
    if (!reverse) {
      // 正順で処理
      // スクロール反転のため並び替え
      for (let i = 0; i < numLines - 2; i++) {
        const index = txt.length - i;
        if (txt[index] !== undefined) {
          wheel.appendChild(txt[index]);
        }
      }
      for (let i = 0; i < numLines - 2; i++) {
        if (reverse) {
          const index = txt.length - i;
          if (txt[index] !== undefined) {
            let clone = txt[index].cloneNode(true);
            clone.classList.add("is-clone");
            wheel.prepend(clone);
          }
        } else {
          const index = txt.length - i;
          if (txt[index] !== undefined) {
            let clone = txt[index].cloneNode(true);
            clone.classList.add("is-clone");
            wheel.appendChild(clone);
          }
        }
      }
    } else {
      // 逆順
      for (let i = 0; i < numLines - 2; i++) {
        const index = txt.length - i;
        if (txt[index] !== undefined) {
          let clone = txt[index].cloneNode(true);
          clone.classList.add("is-clone");
          wheel.prepend(clone);
        }
      }
    }
    gsap.set(wheel, { transformOrigin: "50% 50%" });
    gsap.set(wheel.querySelectorAll(".bl_cylinder_item"), {
      z: radius,
      rotationX: (index) => angle * index,
      transformOrigin: origin,
    });

    // 指定された親要素を取得して、スクロールイベントを実行する
    let targetSelector = elm.dataset.triggerparentselector;
    if (targetSelector === undefined || targetSelector === null) {
      return;
    }
    let parenrtContainer = elm.closest(targetSelector);
    if (parenrtContainer === undefined || parenrtContainer === null) {
      return;
    }

    const currentChild = !reverse ? numItems : 0;
    // Cylinderの初期値
    wheel
      .querySelectorAll(".bl_cylinder_item:nth-child(" + currentChild + ")")
      .forEach(function (o) {
        o.classList.add("is-current");
        console.log(
          o.dataset.collectionname,
          CylinderItem[o.dataset.collectionname]
        );
        if (CylinderItem[o.dataset.collectionname] !== undefined) {
          carousel = createCarousel(parenrtContainer, o.dataset.collectionname);
        }
      });
    gsap.set(wheel, {
      rotationX:
        0 * (100 + (numItems - 1) * 10) +
        (360 / numLines) * (numItems + 1) +
        "_ccw",
    }); // 座標を適用
    if (parenrtContainer.classList.contains("is-pined")) {
      const params = { radian: 0 };
      gsap.to(params, {
        _rotationX: 360,
        radian: Math.PI * 2,
        duration: 8,
        ease: "none",
        repeat: -1,
        transformOrigin: "50% 50%",
      });
      return;
    }

    parenrtContainer.classList.add("is-pined");
    const params = { radian: 0 };

    gsap.to(params, {
      _rotationX: 360,
      radian: Math.PI * 2,
      duration: 8,
      ease: "none",
      repeat: -1,
      transformOrigin: "50% 50%",

      scrollTrigger: {
        //I inserted it in here
        trigger: targetSelector,
        start: "0 20px",
        end: "200% 50%",
        markers: true,
        scrub: true,
        pin: true,
        ease: "none",

        onUpdate: (self) => {
          const { radian, _rotationX } = params;
          const x = Math.cos(radian) * 0;
          const y = Math.sin(radian) * 10;
          gsap.set(wheel, {
            rotationX:
              (self.progress * (100 + (numItems - 1) * 10) +
                (360 / numLines) * (numItems + 1)) *
                1.05 +
              "_ccw",
          }); // 座標を適用
          for (let i = 1; i <= numItems; i++) {
            if (
              self.progress > 1 - (1 / numItems) * i &&
              self.progress <= 1 - (1 / numItems) * (i - 1)
            ) {
              wheel
                .querySelectorAll(
                  ".bl_cylinder_item:nth-child(" + i + "):not(.is-current)"
                )
                .forEach(function (o) {
                  o.classList.add("is-current");
                  if (CylinderItem[o.dataset.collectionname] !== undefined) {
                    carousel = createCarousel(
                      parenrtContainer,
                      o.dataset.collectionname
                    );
                  }
                });
              wheel
                .querySelectorAll(
                  ".bl_cylinder_item:not(:nth-child(" + i + "))"
                )
                .forEach(function (o) {
                  o.classList.remove("is-current");
                });
            }
          }
        },
      },
    });
  });
})();

(function () {
  $(".toggler").each(function () {
    const _this = $(this);
    const ctrl = _this.find(".toggler_ctrl > *");
    const container = _this.find(".toggler_container > *");
    ctrl.on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("is-current")) return false;
      const n = ctrl.index(this),
        other = ctrl.not(this),
        item = container.eq(n);
      other.removeClass("is-current");
      other.find("> *").removeClass("el_cat__current");
      $(this).addClass("is-current");
      $(this).find("> *").addClass("el_cat__current");

      container.not(item).removeClass("is-current");
      item.addClass("is-current");
      return false;
    });
  });
})();

// FAQ アコーディオン
const acc_ttl = Array.from(document.querySelectorAll(".js_faq"));

for (let i = 0; i < acc_ttl.length; i++) {
  let ttl = acc_ttl[i];
  let content = ttl.nextElementSibling;
  ttl.addEventListener("click", () => {
    ttl.classList.toggle("is_active");
    if (content.style.height) {
      content.style.height = null;
    } else {
      content.style.height = content.scrollHeight + "px";
    }
  });
}

if (null !== document.querySelector(".js_main_carousel")) {
  const main = new Splide(".js_main_carousel", {
    type: "fade", // フェード
    rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
    pagination: false, // ページネーション非表示
    arrows: false, // 矢印非表示
  });
  // サムネイル
  const thumbnails = new Splide(".js_thumbnail_carousel", {
    type: "loop", // ループさせる
    perPage: 5, // サムネイル3枚表示
    pagination: false, // ページネーション非表示
    isNavigation: true, // 他のスライダーのナビゲーションとしてそれぞれのスライドをクリック可能にする
    focus: "center", // アクティブなスライドを中央にする
    gap: 12,
    breakpoints: {
      768: {
        gap: 8,
      },
    },
  });
  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();
}

if (window.innerWidth < 768) {
  const mySwiper = new Swiper(".js_flow_slider", {
    slidesPerView: 2,
    spaceBetween: 10,
    grabCursor: true,
    scrollbar: {
      el: ".b_restorationFlow_scroll",
    },
  });
}

$(function () {
  $(".bl_cats__price li a").on("click", function (e) {
    e.preventDefault();
    $(".bl_cats__price li a").removeClass("el_cat__current");
    $(".bl_showcase__price").removeClass("show");
    $(this).addClass("el_cat__current");

    var index = $(".bl_cats__price li a").index(this);
    $(".bl_showcase__price").eq(index).addClass("show");
    $(".bl_showcase__price").eq(index).addClass("splide");

    // moreボタン書き換え
    const collection_url = $(".bl_showcase__price")
      .eq(index)
      .attr("data-collection_url");
    if (
      collection_url !== undefined &&
      collection_url !== null &&
      collection_url !== ""
    ) {
      $(".bl_showcase__price")
        .eq(index)
        .parents(".shopify-section")
        .find(".bl_more a.el_btn")
        .attr("href", collection_url);
    }
  });
});

jQuery(function ($) {
  $("#movie-button").on("click", function () {
    // 任意の再生ボタンが押されたら
    if ($(this).hasClass("playActive")) {
      $(".el_img__movie").get(0).pause();
    } else {
      $(".el_img__movie").get(0).play();
    }
  });

  $(".el_img__movie").on("playing", function () {
    $("#movie-button").addClass("playActive");
    $(this).attr("controls", ""); // ブラウザが表示する再生ボタンを非表示にするために後から属性付与
  });

  $(".el_img__movie").on("pause", function () {
    $("#movie-button").removeClass("playActive");
    $(this).removeAttr("controls");
  });

  $(".el_img__movie").on("ended", function () {
    // android/chrome だと再生終了時に pauseイベント発火しなかったので endedイベントも指定
    $(".playBt").removeClass("playActive");
    $(this).removeAttr("controls");
  });
});

$(function () {
  $(".el_video").each(function () {
    const source = $(this).attr("data-source");
    const source_lg = $(this).attr("data-source-lg");
    if (source_lg === undefined) source_lg = source;
    const poster = $(this).attr("data-poster");
    const poster_lg = $(this).attr("data-poster-lg");
    if (poster_lg === undefined) poster_lg = poster;
    if (window.matchMedia("(min-width: 750px)").matches) {
      $(this).css({ backgroundImage: "url(" + poster_lg + ")" });
      $(this).html($("<source>").attr({ src: source_lg, type: "video/mp4" }));
    } else {
      $(this).css({ backgroundImage: "url(" + poster + ")" });
      $(this).html($("<source>").attr({ src: source, type: "video/mp4" }));
    }
    this.addEventListener(
      "ended",
      function () {
        // 再生しきったら、poster に戻す
        this.load();
        this.autoplay = false;
        $(this).prop("controls", false);
      },
      false
    );

    // 動画が画面内に表示されているか監視：非表示で一時停止
    const observer = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) {
          video_pause(this, 1000);
        } else {
          clearTimeout(Timer[this]);
        }
      }
    });
    observer.observe(this);
  });

  const Timer = [];
  function video_play(_this, ms) {
    clearTimeout(Timer[_this]);
    Timer[_this] = setTimeout(function () {
      _this.play();
    }, ms);
  }
  function video_pause(_this, ms) {
    clearTimeout(Timer[_this]);
    Timer[_this] = setTimeout(function () {
      _this.pause();
    }, ms);
  }
  $(".el_video").on("click", function () {
    if ($(this).prop("controls") === true) {
      // controls 属性があれば何もしない（挙動がかぶる）
      return;
    }
    $(".el_video").each(function () {
      // 全動画の再生を停止
      this.pause();
    });
    $(this).prop("controls", true);
    video_play(this, 30);
  });
});

{
  // DOM取得
  // 親メニューのli要素
  const parentMenuItem = document.querySelectorAll(".p_megamenuOpen");
  console.log(parentMenuItem);

  // イベントを付加
  for (let i = 0; i < parentMenuItem.length; i++) {
    parentMenuItem[i].addEventListener("mouseover", dropDownMenuOpen);
    parentMenuItem[i].addEventListener("mouseleave", dropDownMenuClose);
  }

  // ドロップダウンメニューを開く処理
  function dropDownMenuOpen(e) {
    this.classList.add("is-active");
    // 子メニューa要素
    const childMenuLink = e.currentTarget.querySelector(".p_megamenu");
    console.log(childMenuLink);
    childMenuLink.classList.add("is-active");
  }

  // ドロップダウンメニューを閉じる処理
  function dropDownMenuClose(e) {
    this.classList.remove("is-active");
    // 子メニューリンク
    const childMenuLink = e.currentTarget.querySelector(".p_megamenu");
    console.log(childMenuLink);
    childMenuLink.classList.remove("is-active");
  }
}

const acc_ttl2 = Array.from(document.querySelectorAll(".e_acTtl"));

for (let i = 0; i < acc_ttl2.length; i++) {
  let ttl = acc_ttl2[i];
  let content = ttl.nextElementSibling;
  ttl.addEventListener("click", () => {
    ttl.classList.toggle("is-active");
    console.log(content.style.height);
    if (content.style.height) {
      content.style.height = null;
    } else {
      content.style.height = content.scrollHeight + "px";
    }
  });
}

if (null !== document.querySelector(".splide.infinity_loop")) {
  const infinity_loop = document.querySelectorAll(".splide.infinity_loop");
  const infinityLoopFunc = function (e) {
    console.log(e);
    const splideInfinity = new Splide(e, {
      type: "loop", // ループさせる
      arrows: true,
      pagination: false,
      drag: "free",
      gap: 0, // スライド間の余白
      padding: "20%",
      perPage: 3, // 表示するスライドの枚数
      breakpoints: {
        750: {
          perPage: 2, // 画面幅500px未満で表示枚数1枚
          gap: 0, // 画面幅500px未満でスライド間の余白0
        },
      },
      autoScroll: {
        speed: 1.6, // スクロール速度
        pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない（ライブラリのバグ回避で別途 mouseover イベントで対応する）
      },
    });
    splideInfinity.mount(window.splide.Extensions);
    const splideInfinityAutoScroll = splideInfinity.Components.AutoScroll;
    let splideInfinityTimer;
    $(e).on({
      mouseover: function () {
        clearTimeout(splideInfinityTimer);
        splideInfinityTimer = setTimeout(function () {
          if (splideInfinityAutoScroll.isPaused()) return;
          splideInfinityAutoScroll.pause();
        }, 10);
      },
      mouseleave: function () {
        clearTimeout(splideInfinityTimer);
        splideInfinityTimer = setTimeout(function () {
          if (!splideInfinityAutoScroll.isPaused()) return;
          splideInfinityAutoScroll.play();
        }, 10);
      },
    });
  };
  // イベントを付加
  for (let i = 0; i < infinity_loop.length; i++) {
    infinityLoopFunc(infinity_loop[i]);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // チェックボックス系（PC・モバイル）の input に対応
  const allInputs = document.querySelectorAll('.facet-checkbox input, .mobile-facets__label input');
  allInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      setTimeout(function () {
        location.reload();
      }, 500);
    });
  });

  // .active-facets__button-remove ボタン
  const removeButtons = document.querySelectorAll('.active-facets__button-remove');
  removeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setTimeout(function () {
        location.reload();
      }, 500);
    });
  });

  // .active-facets__button ボタン
  const facetButtons = document.querySelectorAll('.active-facets__button');
  facetButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setTimeout(function () {
        location.reload();
      }, 500);
    });
  });
});